import { get } from 'lib/API';
import Keyword from 'data/Keyword';

export const loadKeywords = async ({ token }: any): Promise<Keyword[]> => {
  return await get(`v1/keywords`, token);
};
